// import { memo, useMemo, useRef } from 'react'
// import { useActivateFilter, useDeactivateFilter, useIsFilterActive } from 'state/kodiakIslands/hooks'
// import { FilterGroup, MemoryFilter } from 'state/kodiakIslands/types'
// import styled from 'styled-components/macro'

// const FilterContainer = styled.div`
//   position: relative;
//   margin-bottom: 16px;
//   width: 100%;
//   max-width: 100%;
//   overflow: hidden;
// `

// const ScrollableArea = styled.div`
//   display: flex;
//   overflow-x: auto;
//   width: 100%;
//   padding: 4px 8px;
//   scrollbar-width: none; /* For Firefox */
//   -ms-overflow-style: none; /* For Internet Explorer and Edge */
//   scroll-behavior: smooth;

//   /* Hide scrollbar for Chrome, Safari and Opera */
//   &::-webkit-scrollbar {
//     display: none;
//   }
// `

// const FiltersWrapper = styled.div`
//   display: flex;
//   gap: 12px;
//   padding: 8px 0;
//   flex-wrap: nowrap;
//   min-width: min-content;
//   position: relative;
// `

// const FilterGroupComp = styled.div`
//   display: flex;
//   align-items: center;
//   width: fit-content;
//   overflow: hidden;
//   border-radius: 6px;
//   flex-shrink: 0;

//   & > div {
//     margin-left: -1px;
//   }

//   & > div:first-child {
//     margin-left: 0;
//   }

//   /* Single filter in group */
//   & > div:only-child {
//     border-radius: 6px;
//   }

//   /* First filter in group (when more than one filter) */
//   & > div:first-child:not(:only-child) {
//     border-top-left-radius: 6px;
//     border-bottom-left-radius: 6px;
//     border-top-right-radius: 0;
//     border-bottom-right-radius: 0;
//   }

//   /* Middle filters in group */
//   & > div:not(:first-child):not(:last-child) {
//     border-radius: 0;
//   }

//   /* Last filter in group (when more than one filter) */
//   & > div:last-child:not(:only-child) {
//     border-top-right-radius: 6px;
//     border-bottom-right-radius: 6px;
//     border-top-left-radius: 0;
//     border-bottom-left-radius: 0;
//   }
// `

// export const FilterItem = styled.div<{ $isActive: boolean }>`
//   display: flex;
//   align-items: center;
//   padding: 8px 16px;
//   background: ${({ theme }) => theme.backgroundSurface || '#191B1F'};
//   border: 1px solid #475569;
//   transition: all 0.2s ease;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
//   flex-shrink: 0;

//   &:hover {
//     border-color: rgba(255, 255, 255, 0.2);
//   }
// `

// export const FilterLabel = styled.span`
//   color: ${({ theme }) => theme.textPrimary || '#FFFFFF'};
//   font-size: 12px;
//   font-weight: 500;
//   margin-right: 12px;
//   white-space: nowrap;
// `

// export const CheckboxContainer = styled.div`
//   width: 20px;
//   height: 20px;
//   border-radius: 4px;
//   border: 2px solid rgba(255, 255, 255, 0.2);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.2s ease;
//   z-index: 1;
//   flex-shrink: 0;
// `

// export const CheckmarkIcon = ({ size = 14 }: { size?: number }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="white"
//     strokeWidth="3"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <polyline points="20 6 9 17 4 12"></polyline>
//   </svg>
// )

// const NewTag = styled.span`
//   background-color: #ff9800;
//   color: white;
//   font-size: 10px;
//   font-weight: bold;
//   padding: 4px 7px;
//   border-radius: 4px;
//   position: absolute;
//   top: -4px;
//   right: -15px;
//   z-index: 99;
// `

// export function Filter({ filter }: { filter: MemoryFilter }) {
//   const isActive = useIsFilterActive(filter)
//   const activateFilter = useActivateFilter(filter)
//   const deactivateFilter = useDeactivateFilter(filter)

//   const toggleFilter = () => {
//     if (isActive) {
//       deactivateFilter()
//     } else {
//       activateFilter()
//     }
//   }

//   return (
//     <FilterItem onClick={toggleFilter} $isActive={isActive}>
//       <FilterLabel>{filter.displayName}</FilterLabel>
//       <CheckboxContainer>{isActive && <CheckmarkIcon />}</CheckboxContainer>
//     </FilterItem>
//   )
// }

// export type FilterRowProps = {
//   filters: MemoryFilter[]
// }

// export default memo(function FilterRow({ filters }: FilterRowProps) {
//   const scrollRef = useRef<HTMLDivElement>(null)

//   const groupedFilters = useMemo(() => {
//     const groups = new Map<FilterGroup | undefined, MemoryFilter[]>()

//     filters.forEach((filter) => {
//       const group = filter.group
//       if (!groups.has(group)) {
//         groups.set(group, [])
//       }
//       groups.get(group)?.push(filter)
//     })

//     return Array.from(groups.entries()).map(([group, filters]) => ({
//       group,
//       filters: filters.sort((a, b) => a.priority - b.priority),
//     }))
//   }, [filters])

//   return (
//     <FilterContainer>
//       <ScrollableArea ref={scrollRef}>
//         <FiltersWrapper>
//           {groupedFilters.map(({ group, filters }) => (
//             <FilterGroupComp key={group || 'default'}>
//               {filters.map((filter) => (
//                 <Filter key={filter.displayName} filter={filter} />
//               ))}
//             </FilterGroupComp>
//           ))}
//           <NewTag>NEW</NewTag>
//         </FiltersWrapper>
//       </ScrollableArea>
//     </FilterContainer>
//   )
// })

import { memo, useMemo, useRef } from 'react'
import { BaseMemoryFilter, FilterSelectionMode, getFilterSelectionMode } from 'state/filterTypes'
import styled from 'styled-components'

const FilterContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`

const ScrollableArea = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100%;
  padding: 4px 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
`

const FiltersWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 0;
  flex-wrap: nowrap;
  min-width: min-content;
  position: relative;
`

const FilterGroupComp = styled.div<{ $selectionMode: FilterSelectionMode }>`
  display: flex;
  align-items: center;
  width: fit-content;
  overflow: hidden;
  border-radius: 6px;
  flex-shrink: 0;
  gap: ${({ $selectionMode }) => ($selectionMode === FilterSelectionMode.MULTI ? '8px' : '0')};

  /* For SINGLE and TOGGLE modes, merge borders */
  ${({ $selectionMode }) =>
    $selectionMode !== FilterSelectionMode.MULTI &&
    `
    & > div {
      margin-left: -1px;
    }

    & > div:first-child {
      margin-left: 0;
    }

    & > div:only-child {
      border-radius: 6px;
    }

    & > div:first-child:not(:only-child) {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    & > div:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    & > div:last-child:not(:only-child) {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  `}
`

export const FilterItem = styled.div<{ $isActive: boolean; $selectionMode?: FilterSelectionMode }>`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.backgroundSurface || '#191B1F'};
  border: 1px solid #475569;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: ${({ $selectionMode }) => ($selectionMode === FilterSelectionMode.MULTI ? '6px' : '0')};

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
  }
`

export const FilterLabel = styled.span`
  color: ${({ theme }) => theme.textPrimary || '#FFFFFF'};
  font-size: 12px;
  font-weight: 500;
  margin-right: 12px;
  white-space: nowrap;
`

export const CheckboxContainer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 1;
  flex-shrink: 0;
`

export const CheckmarkIcon = ({ size = 14 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
)

export const NewTag = styled.span`
  background-color: #ff9800;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 7px;
  border-radius: 4px;
  position: absolute;
  top: -4px;
  right: -15px;
  z-index: 99;
`

interface FilterProps {
  filter: BaseMemoryFilter
  onToggle: (filter: BaseMemoryFilter) => void
}

export function Filter({ filter, onToggle }: FilterProps) {
  const selectionMode = getFilterSelectionMode(filter)

  return (
    <FilterItem onClick={() => onToggle(filter)} $isActive={filter.isActive} $selectionMode={selectionMode}>
      <FilterLabel>{filter.displayName}</FilterLabel>
      <CheckboxContainer>{filter.isActive && <CheckmarkIcon />}</CheckboxContainer>
    </FilterItem>
  )
}

export interface FilterRowProps {
  filters: BaseMemoryFilter[]
  onFilterChange: (filter: BaseMemoryFilter) => void
  showNewBadge?: boolean
}

export default memo(function FilterRow({ filters, onFilterChange, showNewBadge = false }: FilterRowProps) {
  const scrollRef = useRef<HTMLDivElement>(null)

  const groupedFilters = useMemo(() => {
    const groups = new Map<string | undefined, BaseMemoryFilter[]>()

    filters.forEach((filter) => {
      const group = filter.group
      if (!groups.has(group)) {
        groups.set(group, [])
      }
      groups.get(group)?.push(filter)
    })

    return Array.from(groups.entries()).map(([group, filters]) => {
      const sortedFilters = filters.sort((a, b) => a.priority - b.priority)
      const selectionMode = sortedFilters[0] ? getFilterSelectionMode(sortedFilters[0]) : FilterSelectionMode.TOGGLE

      return {
        group,
        filters: sortedFilters,
        selectionMode,
      }
    })
  }, [filters])

  return (
    <FilterContainer>
      <ScrollableArea ref={scrollRef}>
        <FiltersWrapper>
          {groupedFilters.map(({ group, filters, selectionMode }) => (
            <FilterGroupComp key={group || 'default'} $selectionMode={selectionMode}>
              {filters.map((filter) => (
                <Filter key={filter.displayName} filter={filter} onToggle={onFilterChange} />
              ))}
            </FilterGroupComp>
          ))}
          {showNewBadge && <NewTag>NEW</NewTag>}
        </FiltersWrapper>
      </ScrollableArea>
    </FilterContainer>
  )
})
